<template>
    <eg-modalv2
        height="auto"
        :show="showModal"
        :paddingBody="true"
        :showFooter="true"
        :showHeader="true"
        :rounded="true"
        :scrollable="false"
        @close="closeModal()"
    >
        <div slot="header">Preencha os campos e receba uma proposta de nossos consultores.</div>
        <div slot="body" class="modal-body">
            <div>
                <Egfieldset class="mb-4">Seus Dados</Egfieldset>
                <div class="row row-flex">
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Nome do Responsável"
                                :valid="valid"
                                :value="form.name"
                                v-model="form.name"
                                placeholder-text="Nome do Responsável"
                                :rules="textRules"
                                @valid="textRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Telefone"
                                :valid="valid"
                                :value="form.phone"
                                v-model="form.phone"
                                :mask="['(##) ####-####', '(##) #####-####']"
                                placeholder-text="Telefone"
                                :rules="textRules"
                                @valid="textRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Email"
                                :valid="valid"
                                :value="form.email"
                                v-model="form.email"
                                placeholder-text="Email"
                                icon="fas fa-phone-alt"
                                :rules="emailRules"
                                @valid="emailRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Nome Fantasia"
                                :valid="valid"
                                :value="form.tradingName"
                                v-model="form.tradingName"
                                placeholder-text="Nome Fantasia*"
                                :rules="textRules"
                                @valid="textRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                </div>
                <Egfieldset class="mb-4">Dados do Síndico</Egfieldset>
                <div class="row row-flex">
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Nome do Síndico"
                                :valid="valid"
                                :value="form.buildingManagerName"
                                v-model="form.buildingManagerName"
                                placeholder-text="Nome do Síndico"
                                :rules="textRules"
                                @valid="textRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Telefone do síndico"
                                :valid="valid"
                                :value="form.buildingManagerPhone"
                                v-model="form.buildingManagerPhone"
                                :mask="['(##) ####-####', '(##) #####-####']"
                                placeholder-text="Telefone do síndico"
                                :rules="textRules"
                                @valid="textRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                    <div class="col xl12 l12 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Email do síndico"
                                :valid="valid"
                                :value="form.buildingManagerEmail"
                                v-model="form.buildingManagerEmail"
                                placeholder-text="Email do síndico"
                                icon="fas fa-phone-alt"
                                :rules="emailRules"
                                @valid="emailRules.valid = $event"
                                @onblur="validateSubmit()"
                            />
                        </div>
                    </div>
                </div>
                <Egfieldset class="mb-4">Informações da Administradora</Egfieldset>
                <div class="row row-flex">
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Nome da administradora"
                                :valid="valid"
                                :value="form.administratorName"
                                v-model="form.administratorName"
                                placeholder-text="Nome da administradora"
                                :rules="textRulesNotRiquired"
                                @valid="textRulesNotRiquired.valid = $event"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Responsável da administradora"
                                :valid="valid"
                                :value="form.administratorResponsibleName"
                                v-model="form.administratorResponsibleName"
                                placeholder-text="Responsável da administradora"
                                :rules="textRulesNotRiquired"
                                @valid="textRulesNotRiquired.valid = $event"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Telefone da administradora"
                                :valid="valid"
                                :value="form.administratorPhone"
                                v-model="form.administratorPhone"
                                :mask="['(##) ####-####', '(##) #####-####']"
                                placeholder-text="Telefone da administradora"
                                :rules="textRulesNotRiquired"
                                @valid="textRulesNotRiquired.valid = $event"
                            />
                        </div>
                    </div>
                    <div class="col xl6 l6 m12 s12">
                        <div class="input-field">
                            <eg-input
                                title="Email da administradora"
                                :valid="valid"
                                :value="form.administratorEmail"
                                v-model="form.administratorEmail"
                                placeholder-text="Email da administradora"
                                icon="fas fa-phone-alt"
                                :rules="textRulesNotRiquired"
                                @valid="textRulesNotRiquired.valid = $event"
                            />
                        </div>
                    </div>
                </div>
                <Egfieldset class="mb-4">Anexos</Egfieldset>
                <div class="row row-flex">
                    <div class="col xl12 l12 m12 s12">
                        <div class="attachments">
                            <div class="title-second title-input">
                                Faça o up-load do contrato
                            </div>
                            <eg-attachments
                                @update="contractFiles = $event"
                                :clearAttachments="clearAttachments"
                                class="text-space"
                            ></eg-attachments>
                        </div>
                    </div>
                    <div class="col xl12 l12 m12 s12">
                        <div class="attachments">
                            <div class="title-second title-input">Documentos adicionais</div>
                            <eg-attachments
                                attachmentsId="adicionais"
                                @update="additionalFiles = $event"
                                class="text-space"
                                :clearAttachments="clearAttachments"
                            ></eg-attachments>
                        </div>
                    </div>
                </div>
                <Egfieldset class="mb-4 mt-4">Observações</Egfieldset>
                <div class="row row-flex">
                    <div class="col xl12 l12 m12 s12">
                        <div class="input-field">
                            <eg-textarea
                                title="Escreva sobre sua solicitação"
                                v-model.trim="form.observations"
                                :value="form.observations"
                            ></eg-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <eg-button
                @click="sendProposal"
                class="waves-effect waves-light btn-engelink"
                :loading="loading"
                :disabled="!validateForm"
                >Enviar Solicitação</eg-button
            >
        </div>
    </eg-modalv2>
</template>

<script>
import Egfieldset from '@/components/signup/fieldset/';
import { createEngelinkCreditContact } from '@/services';
import { saveFiles } from '@/services/s3-upload-service';

export default {
    components: { Egfieldset },
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        isMobile: Boolean,
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                phone: '',
                tradingName: '',
                observations: '',
                buildingManagerName: '',
                buildingManagerPhone: '',
                buildingManagerEmail: '',
                administratorName: '',
                administratorResponsibleName: '',
                administratorPhone: '',
                administratorEmail: '',
                files: [],
                completeForm: true,
            },
            contractFiles: [],
            additionalFiles: [],
            valid: false,
            textRules: {
                name: '',
                type: 'text',
                required: true,
                valid: true,
            },
            emailRules: {
                name: '',
                type: 'email',
                required: true,
                valid: true,
            },
            textRulesNotRiquired: {
                name: '',
                type: 'text',
                required: false,
                valid: true,
            },
            emailRulesNotRiquired: {
                name: '',
                type: 'email',
                required: false,
                valid: true,
            },
            loading: false,
            validateForm: false,
            clearAttachments: false,
            errorFile: false,
        };
    },
    watch: {
        showModal() {
            if (this.$route.query) {
                this.form.name = this.$route.query.name;
                this.form.email = this.$route.query.email;
                this.form.phone = this.$route.query.phone;
                this.form.tradingName = this.$route.query.trandingName;
            }
        }
    },
    methods: {
        async sendProposal() {
            this.valid = !this.valid;
            this.validateSubmit();
            this.loading = true;
            if (this.validateForm) {
                let files = [];
                try {
                    if (this.contractFiles.length || this.additionalFiles.length) {
                        try {
                            const contractorFiles = await saveFiles(this.contractFiles);
                            const additionalFiles = await saveFiles(this.additionalFiles);
                            files = [
                                ...this.setContractorFiles(contractorFiles),
                                ...this.setAdditionalFiles(additionalFiles),
                            ];
                            this.form.files = files;
                        } catch (error) {
                            console.error(error);
                        }
                    }
                    const formData = { ...this.form };
                    await createEngelinkCreditContact(formData);
                    this.closeModal();
                    this.$emit('successAlert');
                } catch (error) {
                    this.loading = false;
                    this.$emit('errorAlert');
                    console.error(error);
                } finally {
                    this.loading = false;
                    this.validateForm = false;
                }
            } else {
                this.loading = false;
            }
        },
        setContractorFiles(files) {
            files.forEach((file) => {
                file.isContract = true;
            });
            return files;
        },
        setAdditionalFiles(files) {
            files.forEach((file) => {
                file.isContract = false;
            });
            return files;
        },
        closeModal() {
            this.clearAttachments = !this.clearAttachments;
            this.$emit('closeModal');
            this.form.name = '';
            this.form.email = '';
            this.form.phone = '';
            this.form.tradingName = '';
            this.form.observations = '';
            this.form.buildingManagerName = '';
            this.form.buildingManagerPhone = '';
            this.form.buildingManagerEmail = '';
            this.form.administratorName = '';
            this.form.administratorResponsibleName = '';
            this.form.administratorPhone = '';
            this.form.administratorEmail = '';
        },
        validateSubmit() {
            if (!this.form.name.length) return;
            if (!this.form.email.length) return;
            if (!this.form.phone.length) return;
            if (!this.form.tradingName.length) return;
            if (!this.form.buildingManagerName.length) return;
            if (!this.form.buildingManagerPhone.length) return;
            if (!this.form.buildingManagerEmail.length) return;
            this.validateForm = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.modal-body {
    height: 400px;
    overflow-y: scroll;
    .notification {
        display: flex;
        align-content: center;
        justify-content: start;
        gap: 20px;
        padding: 26px 10px;
        border-bottom: 1px solid rgba(165, 165, 165, 0.25);
        .icon {
            color: red;
            font-size: 22px;
            line-height: 20px;
        }
        .content {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
        }
    }
    .unread {
        background-color: #fff;
        font-weight: bold;
        &:hover {
            background-color: #f9f9f9;
            cursor: pointer;
        }
    }
    .read {
        background-color: #f5f5f5;
        .icon {
            color: #a5a5a5;
        }
    }
}

.next-link {
    cursor: pointer;
    margin-top: 10px;
    color: #009fe3;
}

.modal-body::-webkit-scrollbar {
    width: 10px; /* width of the entire scrollbar */
}

.modal-body::-webkit-scrollbar-track {
    background: #fff; /* color of the tracking area */
}

.modal-body::-webkit-scrollbar-thumb {
    background-color: #dbdbdb; /* color of the scroll thumb */
    border-radius: 10px; /* roundness of the scroll thumb */
    border: 2px solid #fff; /* creates padding around scroll thumb */
}

// ::v-deep .modal-container {
//     border-radius: 0px 0px 7px 7px;
// }

.slide-fade-enter-active {
    transition: all 0.3s ease;
}
.slide-fade-leave-active {
    transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}
::v-deep .multiselect__content-wrapper {
    min-width: fit-content;
    box-shadow: 0px 3px 6px #00000029;
    overflow-y: visible;
}
@media screen and (max-width: 768px) {
    ::v-deep .modal-body.padding-body {
        padding: 1rem;
    }
    .content {
        flex-direction: column-reverse;
        align-items: flex-start !important;
        text-align: left;
        .data {
            font-size: 12px;
            margin-bottom: 8px;
        }
    }
}
.title-second {
    margin-top: 1rem;
}
</style>
